// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SmsFileContentsTable_wrapper__2ZS2Y","table":"SmsFileContentsTable_table__2E3TB","footnote":"SmsFileContentsTable_footnote__39oF3"};